import { createContext, useContext } from 'react';

// Holds the authenticated user's preferred language as a full LocaleDto
// ({ languageCode, countryCode }) or null when unknown/not set. Populated by App
// after it fetches the profile, and kept in sync when the user changes the
// language in the settings overlay. Consumed to pre-select the "I speak" student
// locale (see defaultStudentLocaleIso in api.js).
export const PreferredLocaleContext = createContext({
  preferredLocale: null,
  setPreferredLocale: () => {},
});

export function usePreferredLocale() {
  return useContext(PreferredLocaleContext);
}
